// extracted by mini-css-extract-plugin
module.exports = {"buttonUndo":"ButtonUndo_buttonUndo__1jxP4"};